module.exports = __webpack_public_path__ + "img/icon.33f0431b.png";